





























































import { EpigraphicUnitSide, MarkupUnit } from '@oare/types';
import { defineComponent, PropType, ref, computed } from '@vue/composition-api';

export default defineComponent({
  props: {
    side: {
      type: String as PropType<EpigraphicUnitSide>,
      required: true,
    },
    sideMarkup: {
      type: Array as PropType<MarkupUnit[]>,
      required: false,
    },
    selected: {
      type: Boolean,
      required: true,
    },
    showEditButton: {
      type: Boolean,
      default: true,
    },
  },
  setup(props) {
    const sideEditMenu = ref(false);

    const formatSide = computed(() => {
      if (props.sideMarkup) {
        if (props.sideMarkup.map(markup => markup.type).includes('uncertain')) {
          return `${props.side}<sup>?</sup>`;
        } else if (
          props.sideMarkup
            .map(markup => markup.type)
            .includes('isEmendedReading')
        ) {
          return `${props.side}<sup>!</sup>`;
        }
        return props.side;
      }
      return props.side;
    });

    return {
      sideEditMenu,
      formatSide,
    };
  },
});
